import Axios from "axios";
import store from "../form-store";
import { toggleLoader } from "../form-store/app-reducer";

//request interceptor
Axios.interceptors.request.use(
  function (config) {
    store.dispatch(toggleLoader());
    return config;
  },
  function (error) {
    store.dispatch(toggleLoader());
    return Promise.reject(error);
  }
);

//response interceptor
Axios.interceptors.response.use(
  function (response) {
    store.dispatch(toggleLoader());

    return response;
  },
  function (error) {
    store.dispatch(toggleLoader());

    return Promise.reject(error);
  }
);

export default async function serviceCall(url, method = "GET", data = {}, headers = {}) {
  return Axios({
    url,
    method,
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "Access-Control-Allow-Origin": "*",
      ...headers,
    },
    withCredentials: true,
    redirect: "follow",
    data: JSON.stringify(data),
  }).then(response => {
    return response;
  });
}
